import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '~/app/components/common/ConfirmDialog/ConfirmDialog';

type ConfirmPermissionsModalProps = {
  open: boolean;
  isSystemRole: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ConfirmPermissionsModal({
  open,
  isSystemRole,
  loading,
  onCancel,
  onConfirm,
}: ConfirmPermissionsModalProps) {
  const { t } = useTranslation('authorization');

  return (
    <ConfirmDialog
      open={open}
      variant={isSystemRole ? 'warning' : 'primary'}
      title={
        isSystemRole
          ? t('detail.confirmSystemRoleTitle')
          : t('detail.confirmTitle')
      }
      description={
        isSystemRole
          ? t('detail.confirmSystemRoleBody')
          : t('detail.confirmBody')
      }
      confirmLabel={t('detail.confirmOk')}
      cancelLabel={t('detail.confirmCancel')}
      loading={loading}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
}
